import { render, staticRenderFns } from "./TablaReu.vue?vue&type=template&id=7611c25c"
import script from "./TablaReu.vue?vue&type=script&lang=js"
export * from "./TablaReu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports